import { render, staticRenderFns } from "./UnsendConfirm.vue?vue&type=template&id=42995ee2&"
import script from "./UnsendConfirm.vue?vue&type=script&lang=ts&"
export * from "./UnsendConfirm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports